import { VStack } from "native-base";
import React, { useState } from "react";
import { FlatList } from "react-native";

import Container from "@/components/organisms/Container";
import { useAppNavigation } from "@/hooks/application/navigation";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import CardLoading from "../components/CardLoading";
import EmptyCard from "../components/EmptyCard";
import HeaderWithSearchBar from "../components/HeaderWithSearchBar";
import ProductCard from "../components/ProductCard";
import SortCard from "../components/SortCard";
import { InStoreSearchScreenProps } from "../types";

const InStoreSearchMobile = ({
  products,
  isLoading,
  currentSearch,
  handleSearch,
  onLoadMore,
  onBackPress,
  onSelectSortType,
}: InStoreSearchScreenProps) => {
  const { navigate } = useAppNavigation<HomeNavigation>();
  const [recentQuerySelected, setRecentQuerySelected] = useState(null);
  const renderLoader = () => (
    <FlatList
      data={new Array(10).fill(null)}
      keyExtractor={(_, index) => index.toString()}
      showsVerticalScrollIndicator={false}
      renderItem={() => <CardLoading />}
    />
  );
  return (
    <Container
      px="0"
      Header={
        <HeaderWithSearchBar
          initialValue={recentQuerySelected}
          onBackPress={onBackPress}
          onChangeText={handleSearch}
        />
      }>
      <VStack mb="32">
        {(!products && !isLoading) || products?.length === 0 ? (
          <EmptyCard
            currentSearch={products?.length === 0 ? currentSearch : null}
            onSelectRecentQuery={(val) => {
              setRecentQuerySelected(val);
              handleSearch(val);
            }}
          />
        ) : (
          <VStack px="2">
            <SortCard onSelectSortOption={onSelectSortType} />
            {isLoading && renderLoader()}
            {!!products?.length && !isLoading && (
              <FlatList
                data={products}
                nestedScrollEnabled
                keyExtractor={(item, index) => (item ? item._id : index.toString())}
                showsVerticalScrollIndicator={false}
                onEndReached={onLoadMore}
                onEndReachedThreshold={0.1}
                renderItem={({ item }) => (
                  <ProductCard
                    product={item}
                    showStoreName={false}
                    onSelectProduct={() =>
                      navigate("product", {
                        productId: item._id,
                      })
                    }
                  />
                )}
              />
            )}
          </VStack>
        )}
      </VStack>
    </Container>
  );
};

export default InStoreSearchMobile;
